import { render, staticRenderFns } from "./ParticipantTag.vue?vue&type=template&id=a9afabdc&scoped=true"
import script from "./ParticipantTag.vue?vue&type=script&lang=ts"
export * from "./ParticipantTag.vue?vue&type=script&lang=ts"
import style0 from "./ParticipantTag.vue?vue&type=style&index=0&id=a9afabdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9afabdc",
  null
  
)

export default component.exports